import Try from '@/util/try';
import { type Response, type DirectoryBooking, CRMError } from './CRM';
import { GenericPlatform } from './platform';
import { videoDirectoryOdoo } from '@/util/api';

export class Odoo extends GenericPlatform {
  platform = 'odoo';

  override async recordDirectoryBooking(
    details: DirectoryBooking
  ): Promise<Response> {
    const [error] = await Try(videoDirectoryOdoo(details));

    if (error) {
      return { success: false, error: new CRMError(error.message) };
    }

    return { success: true, error: undefined };
  }
}
